import React from 'react';
import PropTypes from 'prop-types';

import { IconButton, Add, Subtract } from '@tds/core-interactive-icon';
import { FieldRowWrapper, StyledLabelWrapper, PlusMinusWrapper } from './css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const FieldPlusMinusInput = ({ data }) => {
  const {
    ref,
    name,
    label,
    value,
    minValue,
    maxValue,
    onChange,
    incrementStep,
    hideButtons,
    formFields,
    isHidden,
    onValueOverLimit
  } = data;

  const localizedStrings = useLocalizedStringsContext();
  const {
    fieldPlusMinus: { buttonMinus, buttonPlus }
  } = localizedStrings;

  const checkIfValueOverLimit = val => {
    let newValue = val;
    if (newValue < (minValue || 0)) newValue = minValue || 0;

    if (typeof maxValue === 'number' && newValue > maxValue) {
      newValue = maxValue;
      if (onValueOverLimit) onValueOverLimit(maxValue);
    }

    return newValue;
  };

  const incrementValue = e => {
    e.preventDefault();
    const newValue = parseInt(value || 0, 10) + (incrementStep || 1);
    e.target.value = checkIfValueOverLimit(newValue).toString();
    e.target.name = name;
    onChange(e);
  };

  const decrementValue = e => {
    e.preventDefault();
    const newValue = parseInt(value || 0, 10) - (incrementStep || 1);
    e.target.value = checkIfValueOverLimit(newValue).toString();
    e.target.name = name;
    onChange(e);
  };

  const labelLogic =
    formFields && formFields.secureBusinessComments
      ? label.split('($')[0]
      : label;
  return (
    <>
      {!isHidden && (
        <FieldRowWrapper>
          {label && (
            <StyledLabelWrapper>
              <span className="frg-body-font-14px">{labelLogic}</span>
            </StyledLabelWrapper>
          )}
          <PlusMinusWrapper>
            {!hideButtons && (
              <IconButton
                icon={Subtract}
                onClick={decrementValue}
                a11yText={buttonMinus}
              />
            )}
            <input
              ref={ref}
              id={name}
              name={name}
              type="number"
              value={value}
              readOnly
              style={{ width: '50px', padding: '0', textAlign: 'center' }}
              className="frg-input-field color-light"
            />
            {!hideButtons && (
              <IconButton
                icon={Add}
                onClick={incrementValue}
                a11yText={buttonPlus}
              />
            )}
          </PlusMinusWrapper>
        </FieldRowWrapper>
      )}
    </>
  );
};

FieldPlusMinusInput.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.object, // eslint-disable-line
    label: PropTypes.string,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    incrementStep: PropTypes.number,
    hideButtons: PropTypes.bool,
    isHidden: PropTypes.bool,
    onValueOverLimit: PropTypes.func,
    value: PropTypes.string,
    name: PropTypes.string.isRequired,
    formFields: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
  }).isRequired
};

export default FieldPlusMinusInput;
